import React, { useEffect, useRef, useState } from "react";
import "./Profitloss.css";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import back from "../../imgs/backexam.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Profitloss = (props) => {
  const { t } = useTranslation();

  const [input, setInput] = useState({
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    kno: "",
    kname: "",
    lastkhadya: "",
    lastadv: "",
    lastdate: "",
    dno: "",
    name: "",
    khname: "",
    searchsank: "",
  });

  const inputRefs = useRef([]);
  const [DataSource, setDataSource] = useState([]);
  const [value, setValue] = useState("");
  const [PreviousAmt, setPreviousAmt] = useState();
  const [wait, setWait] = useState(false);

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  const navigate = useNavigate();

  function handleEnterKey(event, currentIndex) {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();

      let nextIndex = null;
      if (currentIndex === 2) {
        if (input.name !== "") nextIndex = currentIndex + 1;
        else nextIndex = currentIndex;
      } else {
        nextIndex = currentIndex + 1;
      }

      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  }

  const showprint = () => {
    if (DataSource && DataSource.length > 0) {
      localStorage.setItem("date1print", input.date1);
      localStorage.setItem("date2print", input.date2);
      const url = "/profitlossprint";
      window.open(url, "_blank");
    } else {
      notifyerror(t("Profitloss.toast.noDataForPeriod"));
    }
  };

  const handleChange = async (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;

    // normal update
    setInput((prev) => ({ ...prev, [name]: valuecurrent }));

    // date2 validation (limit 1 month)
    if (name === "date2") {
      const date1 = new Date(input.date1);
      const date2 = new Date(valuecurrent);
      const differenceInDays = (date2 - date1) / (1000 * 60 * 60 * 24);

      if (differenceInDays <= 30) {
        setInput((prevInput) => ({ ...prevInput, [name]: valuecurrent }));
      } else {
        notifyerror(t("Profitloss.toast.reportLimitOneMonth"));
        setInput((prevInput) => ({
          ...prevInput,
          [name]: new Date().toISOString().substr(0, 10),
        }));
      }
    }
  };

  const getprofitloss = () => {
    setValue("");
    setWait(true);

    var mainuser2 = jsEncode.encode("mamapr", 125);
    const landingphp = "getprofitandloss4.php";

    let rawData = {
      date1: input.date1,
      date2: input.date2,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    };

    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post(`https://excellentdairy.com/dairy/php/cust/${landingphp}`, formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          setDataSource(response.data);
          setWait(false);
        } else {
          notifyerror(t("Profitloss.toast.noData"));
          setDataSource([]);
          setWait(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setWait(false);
      });
  };

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  function groupByHead(data, isPositive = true) {
    return data.reduce((acc, row) => {
      const head = isPositive ? row.positive_head : row.negative_head;
      if (!head) return acc;

      if (!acc[head]) acc[head] = { total: 0, records: [] };

      const amt = isPositive
        ? parseFloat(row.positive_amount || 0)
        : parseFloat(row.negative_amount || 0);

      acc[head].total += amt;
      acc[head].records.push(row);
      return acc;
    }, {});
  }

  function toGroupArray(groupedObj) {
    return Object.entries(groupedObj).map(([head, info]) => ({
      head,
      total: info.total,
      records: info.records,
    }));
  }

  const sourceData = DataSource;
  const posDict = groupByHead(sourceData, true);
  const negDict = groupByHead(sourceData, false);
  const posGroups = toGroupArray(posDict);
  const negGroups = toGroupArray(negDict);

  const posRows = posGroups.reduce((sum, group) => sum + group.records.length + 1, 0);
  const negRows = negGroups.reduce((sum, group) => sum + group.records.length + 1, 0);
  const maxRows = Math.max(posRows, negRows);

  function addBlankRows(groups, totalRows) {
    let currentRows = groups.reduce((sum, group) => sum + group.records.length + 1, 0);
    let blanksNeeded = totalRows - currentRows;

    if (blanksNeeded > 0) {
      groups.push({
        head: "",
        total: 0,
        records: new Array(blanksNeeded).fill({
          positive_kno: "",
          positive_name: "",
          positive_amount: "",
        }),
      });
    }
    return groups;
  }

  const posGroupsFilled = addBlankRows([...posGroups], maxRows);
  const negGroupsFilled = addBlankRows([...negGroups], maxRows);

  const grandPosTotal = sourceData.reduce((sum, row) => sum + parseFloat(row.positive_amount || 0), 0);
  const grandNegTotal = sourceData.reduce((sum, row) => sum + parseFloat(row.negative_amount || 0), 0);

  return (
    <>
      <ToastContainer />

      <div className="sanklanmain">
        <div className="firstrowsank">
          <img onClick={props.visibility} className="back" src={back} alt="" />

          <div className="colmain">
            <div className="firstrow2">
              <div className="rowbill">
                <>
                  <div className="mb-2">
                    <span className="subheadsank">{t("Profitloss.filters.date")}</span>
                    <input
                      onKeyDown={(e) => handleEnterKey(e, 0)}
                      ref={(ref) => (inputRefs.current[0] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date1"
                      name="date1"
                      value={input.date1}
                      onChange={handleChange}
                    />
                  </div>

                  <span className="subheadbill">{t("Profitloss.filters.to")}</span>

                  <div className="mb-2">
                    <span className="subheadsank">{t("Profitloss.filters.date")}</span>
                    <input
                      onKeyDown={(e) => handleEnterKey(e, 1)}
                      ref={(ref) => (inputRefs.current[1] = ref)}
                      type="date"
                      className="form-control"
                      autoComplete="off"
                      id="date2"
                      name="date2"
                      value={input.date2}
                      onChange={handleChange}
                    />
                  </div>
                </>

                <div className="mb-2">
                  {wait ? (
                    <button
                      ref={(ref) => (inputRefs.current[4] = ref)}
                      type="submit"
                      id="show"
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("Profitloss.common.loading")}
                    </button>
                  ) : (
                    <button
                      onClick={getprofitloss}
                      ref={(ref) => (inputRefs.current[4] = ref)}
                      type="submit"
                      id="show"
                      className="btn btn-primary mx-1 sanksmall"
                    >
                      {t("Profitloss.buttons.viewReport")}
                    </button>
                  )}

                  <button
                    onClick={showprint}
                    ref={(ref) => (inputRefs.current[4] = ref)}
                    type="submit"
                    id="print"
                    className="btn btn-primary mx-1 sanksmall"
                  >
                    {t("Profitloss.buttons.print")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* TABLES */}
        <div className="firstrow2">
          <div className="table-containerbill">
            <div style={{ display: "flex" }}>
              {/* Positive Side Table */}
              <div style={{ width: "50%", paddingRight: "0%" }}>
                <table id="myTablebill" className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="thlarge">{t("Profitloss.table.debitSide")}</th>
                      <th className="thsmall">{t("Profitloss.table.subAmount")}</th>
                      <th className="thsmall">{t("Profitloss.table.amount")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {posGroupsFilled.map((group, gIndex) => (
                      <React.Fragment key={`pos-group-${gIndex}`}>
                        {group.head && (
                          <tr style={{ backgroundColor: "#eee", fontWeight: "bold" }}>
                            <td className="thsmallnavelefttale" colSpan="2">
                              {group.head}
                            </td>
                            <td className="thsmallright">{group.total.toFixed(2)}</td>
                          </tr>
                        )}

                        {group.records.map((rec, rIndex) => (
                          <tr key={`pos-group-${gIndex}-row-${rIndex}`}>
                            <td className="thsmallcust">
                              {rec.positive_kno ? `${rec.positive_kno} : ${rec.positive_name}` : ""}
                            </td>
                            <td className="thsmallcust">
                              {rec.positive_amount ? parseFloat(rec.positive_amount).toFixed(2) : ""}
                            </td>
                            <td className="thsmallcust">{t("Profitloss.common.dash")}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thlargegreen2">{t("Profitloss.common.dash")}</td>
                      <td className="thsmallgreen2">{t("Profitloss.common.dash")}</td>
                      <td className="thsmallgreen2">{grandPosTotal.toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              {/* Negative Side Table */}
              <div style={{ width: "50%", paddingLeft: "0%" }}>
                <table id="myTablebill" className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="thlarge">{t("Profitloss.table.creditSide")}</th>
                      <th className="thsmall">{t("Profitloss.table.subAmount")}</th>
                      <th className="thsmall">{t("Profitloss.table.amount")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {negGroupsFilled.map((group, gIndex) => (
                      <React.Fragment key={`neg-group-${gIndex}`}>
                        {group.head && (
                          <tr style={{ backgroundColor: "#eee", fontWeight: "bold" }}>
                            <td className="thsmallnavelefttale" colSpan="2">
                              {group.head}
                            </td>
                            <td className="thsmallright">{group.total.toFixed(2)}</td>
                          </tr>
                        )}

                        {group.records.map((rec, rIndex) => (
                          <tr key={`neg-group-${gIndex}-row-${rIndex}`}>
                            <td className="thsmallcust">
                              {rec.negative_kno ? `${rec.negative_kno} : ${rec.negative_name}` : ""}
                            </td>
                            <td className="thsmallcust">
                              {rec.negative_amount ? parseFloat(rec.negative_amount).toFixed(2) : ""}
                            </td>
                            <td className="thsmallcust">{t("Profitloss.common.dash")}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr style={{ backgroundColor: "lightgray", fontWeight: "bold" }}>
                      <td className="thlargegreen2">{t("Profitloss.common.dash")}</td>
                      <td className="thsmallgreen2">{t("Profitloss.common.dash")}</td>
                      <td className="thsmallgreen2">{grandNegTotal.toFixed(2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
ou
    </>
  );
};

export default Profitloss;
